/**
 * Prefix of the passthrough ticket the form mints for an instance that had no
 * undeclared subfield before the cataloguer added one. The load path mints
 * `pt<n>` (`genericProposalDataToForm`), so every row under an `add<n>` ticket
 * is one the cataloguer added in this form.
 */
var ADDED_TICKET_PREFIX = 'add';
export var addedTicket = function (n) { return "".concat(ADDED_TICKET_PREFIX).concat(n); };
export var isAddedTicket = function (ticket) { return ticket.startsWith(ADDED_TICKET_PREFIX); };
/**
 * The catalog's entry for `tag $code` when the cataloguer may write it: the
 * field and the subfield are listed, and neither is `forbidden` or `readonly`.
 */
export var writableCatalogSubfield = function (catalog, tag, code) {
    var _a, _b;
    var field = (_a = catalog === null || catalog === void 0 ? void 0 : catalog.marc21Fields) === null || _a === void 0 ? void 0 : _a[tag];
    if (!field || (field.input_policy && field.input_policy !== 'allowed'))
        return undefined;
    var entry = (_b = field.subfields) === null || _b === void 0 ? void 0 : _b.find(function (s) { return s.code === code; });
    if (!entry || (entry.input_policy && entry.input_policy !== 'allowed'))
        return undefined;
    return entry;
};
/**
 * The catalog subfields the cataloguer may add to an instance of `fieldDef`
 * that already holds the undeclared codes `present`, in catalog order: writable
 * per {@link writableCatalogSubfield}, not declared by the template, not one the
 * template keeps out of the offer (`offerExcludedSubfields`, CZNA-1527), and —
 * when the catalog says the subfield is not repeatable — not in the instance yet.
 *
 * <p>CZNA-1527 — the exclusion is a filter on the OFFER only. The ontology allows
 * the whole of MARC 21 and NK uses a fraction of it, so a template may name the
 * codes its cataloguers have no use for; `forbidden` would say something else (and
 * reach validation). A record that already holds such a code — from Aleph, say —
 * still shows and edits it: that path asks {@link writableCatalogSubfield}, which
 * the list does not touch.
 */
export var addableSubfields = function (catalog, fieldDef, present) {
    var _a, _b, _c, _d;
    var declared = new Set(fieldDef.subfields.map(function (sf) { return sf.code; }));
    var excluded = new Set((_a = fieldDef.offerExcludedSubfields) !== null && _a !== void 0 ? _a : []);
    return ((_d = (_c = (_b = catalog === null || catalog === void 0 ? void 0 : catalog.marc21Fields) === null || _b === void 0 ? void 0 : _b[fieldDef.tag]) === null || _c === void 0 ? void 0 : _c.subfields) !== null && _d !== void 0 ? _d : [])
        .filter(function (s) { return writableCatalogSubfield(catalog, fieldDef.tag, s.code) !== undefined; })
        .filter(function (s) { return !declared.has(s.code); })
        .filter(function (s) { return !excluded.has(s.code); })
        .filter(function (s) { return s.repeatable_default || !present.includes(s.code); });
};
